import React, { FC } from 'react';
import Image from 'next/image';
import { Icon } from '@/components/atomic/Icon';
import { useBreakPointDown } from '@/hooks/breakPoint';
import { Link } from '../Link';

interface IExternalSiteEntryProps {
  title: string;
  imageSrc: string;
  imageAlt: string;
  link: string;
  mobileLink?: string;
}

export const ExternalSiteEntry: FC<IExternalSiteEntryProps> = ({
  title,
  imageSrc,
  link,
  mobileLink,
  imageAlt,
}) => {
  const isMdDown = useBreakPointDown('md');
  const href = isMdDown && mobileLink ? mobileLink : link;

  return (
    <Link
      className="flex min-h-[40px] items-center gap-x-2 rounded-lg bg-gray-00 px-2 text-xs font-regular text-mofidblue-filled-primary-enabled"
      href={href}
    >
      <Image alt={imageAlt} height={24} src={imageSrc} width={24} />
      {title}
      <Icon className="mr-auto" color="#848D99" icon="chevron_left" size={16} />
    </Link>
  );
};
